import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/gongzhonghao.jpg'
import _imports_1 from '@/assets/image/customerservice.png'
import _imports_2 from '@/assets/icon/gongan.png'


const _withScopeId = n => (_pushScopeId("data-v-74e2f4d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-box" }
const _hoisted_2 = {
  class: "footer",
  id: "footer"
}
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "fd-link" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "关联网站")
  ]),
  /*#__PURE__*/_createElementVNode("dd", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.tjchenxing.com"
    }, "辰星（天津）自动化设备有限公司")
  ]),
  /*#__PURE__*/_createElementVNode("dd", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.movibot-art.com/"
    }, "工业机器人供应链优选平台")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"fd-tel\" data-v-74e2f4d6><p class=\"title\" data-v-74e2f4d6>企业服务热线:</p><span class=\"tel\" data-v-74e2f4d6>400-653-7789</span><span class=\"tel phone\" data-v-74e2f4d6>155-2241-5492</span><p class=\"service\" data-v-74e2f4d6> 服务时间：8:30-17:30 (周一至周六,法定节假日除外) </p><p class=\"info\" data-v-74e2f4d6>企业服务邮箱 : shejiyuan@tjchenxing.com</p></div>", 1)
const _hoisted_7 = { class: "fd-r" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-r-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qr" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "pic" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "微信公众号")
  ])
], -1))
const _hoisted_9 = { class: "fd-r-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qr" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pic" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "客服微信号")
], -1))
const _hoisted_11 = { class: "share" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filing-no" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Copyright©2023 设纪元sjyuan.net.cn "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://beian.miit.gov.cn/",
      target: "_blank"
    }, "津ICP备17008102号-2"),
    /*#__PURE__*/_createTextVNode(" | "),
    /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
    /*#__PURE__*/_createTextVNode("  "),
    /*#__PURE__*/_createElementVNode("a", { href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12011602001036" }, "津公网安备12011602001036号")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Share = _resolveComponent("Share")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, [
                _createVNode(_component_router_link, { to: {
									name: 'aboutsite',
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("平台保障")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'privacyPolicy',
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("隐私政策")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'renzheng',
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("实名认证")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'aboutsite',
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("使用规则")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'cooperation',
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("合作协议")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, [
                _createVNode(_component_router_link, { to: {
									name: 'guidance',
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("帮助中心")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'guidance',
									params: {
										comName: 'Shopping',
									},
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("购物流程")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'customer',
									params: {
										comName: 'GeRenVip',
									},
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("会员制度")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'customer',
									params: {
										comName: 'Fapiao',
									},
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("发票制度")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'guidance',
									params: {
										comName: 'Consult',
									},
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("咨询服务")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, [
                _createVNode(_component_router_link, { to: {
									name: 'aboutour',
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 关于设纪元 ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'aboutour',
									params: { id: 1 },
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("关于我们")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'aboutour',
									params: { id: 2 },
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("服务理念")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: {
									name: 'aboutour',
									params: { id: 3 },
								} }, {
                  default: _withCtx(() => [
                    _createTextVNode("联系我们")
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_5
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Share)
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_12
  ], 64))
}